/**
 * Copyright (c) 2019 2020 2021 2022 AIGIA. All Rights Reserved.
 * see license.txt
 */

"use strict";

import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild} from "@angular/core";
import {FloatingComponent} from "../floating/floating.component";

interface IRect {
	x: number,
	y: number,
	w: number,
	h: number
}

interface ISize {
	w: number,
	h: number
}

/**
 * todo
 */
@Component({
	selector: "aigia-trajectory",
	templateUrl: "./trajectory.component.html",
	styleUrls: ["../floating/floating.component.css", "./trajectory.component.css"]
})

export class TrajectoryComponent extends FloatingComponent implements OnInit, OnChanges, AfterViewInit {

	@Input() public size: number[] = [200, 770];
	@Input() public locked: boolean;
	@Input() public shots: any[];

	public title: string = "Trajectory";

	@ViewChild("traj", {read: ElementRef}) private canvas_ref: ElementRef;

	private canvas: any;
	private context: any;
	private resizedFrame: IRect;

	@Output() public progrssChange = new EventEmitter<boolean>();

	private text_option: any = {};
	private stroke_option: any = {};

	private colorScheme: string[] = ["#1CBCD880", "#FF8D6080", "#FF586B80", "#5c6bc080", "#3d5afe80", "#4caf5080", "#673ab780"];

	/**
	 * @returns none
	 */
	private clearCanvas(): void {
		this.canvas.getContext("2d").clearRect(0, 0, this.canvas.width, this.canvas.height);
	}

	/**
	 * @returns none
	 */
	private oval(x: number, y: number, w: number, h: number): void {
		this.context.save();
		this.context.beginPath();
		this.context.translate(x, y);
		this.context.scale(w / 2, h / 2);
		this.context.arc(1, 1, 1, 0, 2 * Math.PI, false);
		this.context.closePath();
		this.context.restore();
	}

	/**
	 * @returns none
	 */
	private lineTo(x: number, y: number, angle: number, start: number, end: number, option: any, text: (context: any) => void): void {
		this.context.save();
		this.context.translate(x, y);
		this.context.rotate(angle * Math.PI / 180);

		this.context.beginPath();
		this.context.rect(-end, -start, end - start, 3);
		this.context.fillStyle = option.line_color;
		this.context.fill();

		this.oval(-end, -5, 10, 10);
		this.context.fillStyle = option.point_color;
		this.context.fill();

		this.oval(-start, -5, 10, 10);
		this.context.fillStyle = option.point_color;
		this.context.fill();

		text(this.context);

		this.context.restore();
	}

	/**
	 * @returns none
	 */
	private pointTo(x: number, y: number, angle: number, start: number, end: number, option: any, text: (context: any) => void): void {
		this.context.save();
		this.context.translate(x, y);
		this.context.rotate(angle * Math.PI / 180);

		this.context.beginPath();

		this.oval(-end, -5, 10, 10);
		this.context.fillStyle = option.point_color;
		this.context.fill();

		this.oval(-start, -5, 10, 10);
		this.context.fillStyle = option.point_color;
		this.context.fill();

		// 	text(this.context);

		this.context.restore();
	}

	/**
	 * @returns none
	 */
	private text(text: string, x: number, y: number, option: any): void {
		this.context.save();
		this.context.fillStyle = option.line_color;
		this.context.font = option.font;
		this.context.textAlign = "center";
		const textTotalHeight = 13 * 1.3;
		const v_textRect = this.makeRect(x, y, 50, 24);
		this.context.fillText(text, v_textRect.x, v_textRect.y + 12 + v_textRect.h / 2 - textTotalHeight / 2);
		this.context.restore();
	}

	/**
	 * @returns rect
	 */
	private makeRect(x: number, y: number, w: number, h: number): IRect {
		return {x, y, w, h};
	}

	/**
	 * @returns equal
	 */
	private equalRects(r1: any, r2: any): boolean {
		return r1.x === r2.x && r1.y === r2.y && r1.w === r2.w && r1.h === r2.h;
	}

	/**
	 * @returns size
	 */
	private makeSize(w: number, h: number): ISize {
		return {w, h};
	}

	/**
	 * @returns string
	 */
	private color(index: number): string {
		return this.colorScheme[index % (this.colorScheme.length + 1)];
	}

	/**
	 * @returns none
	 */
	private initializeCanvas(): void {
		const devicePixelRatio: number = 1;// window.devicePixelRatio || 1;
		const backingStorePixelRatio: number = this.context.webkitBackingStorePixelRatio
			|| this.context.mozBackingStorePixelRatio
			|| this.context.msBackingStorePixelRatio
			|| this.context.oBackingStorePixelRatio
			|| this.context.backingStorePixelRatio
			|| 1;

		const pixelRatio: number = devicePixelRatio / backingStorePixelRatio;

		this.canvas.style.width = this.canvas.width + "px";
		this.canvas.style.height = this.canvas.height + "px";
		this.canvas.width *= pixelRatio;
		this.canvas.height *= pixelRatio;
		this.canvas.paintCodePixelRatio = pixelRatio;
		this.context.scale(pixelRatio, pixelRatio);
	}

	/**
	 * @returns none
	 */
	public ngOnChanges(changes: any): void {
		if (this.canvas) {
			Object.keys(changes).forEach((propName) => {
				switch (propName) {
					case "visible":
					case "size":
						if (this.visible) {
							this.canvas.width = changes.size.currentValue[0];
							this.canvas.height = changes.size.currentValue[1];
						}
						break;
					default:
						break;
				}
			});
			// 	this.clearCanvas();
			this.initializeCanvas();
			this.draw(this.shots);
		}
	}

	/**
	 * @returns none
	 */
	public ngOnInit(): void {

		const dark_text_option = {
			line_color: "rgba(255,255,255)",
			point_color: "rgba(150,150,150)",
			font: "bold 14px HelveticaNeue, \"Helvetica Neue\", Helvetica, Arial, sans-serif"
		};

		const neutral_text_option = {
			line_color: "rgba(150,150,150)",
			point_color: "rgba(150,150,150)",
			font: "bold 14px HelveticaNeue, \"Helvetica Neue\", Helvetica, Arial, sans-serif"
		};

		const light_text_option = {
			line_color: "rgba(85,85,85)",
			point_color: "rgba(150,150,150)",
			font: "bold 14px HelveticaNeue, \"Helvetica Neue\", Helvetica, Arial, sans-serif"
		};

		const dark_stroke_option = {
			color: "rgba(255,255,255)",
			width: 2
		};

		const neutral_stroke_option = {
			color: "rgba(150,150,150)",
			width: 2
		};

		const light_stroke_option = {
			color: "rgba(85,85,85)",
			width: 2
		};

		this.text_option = neutral_text_option;
		this.stroke_option = neutral_stroke_option;

	}

	/**
	 * @returns none
	 */
	public ngAfterViewInit(): void {
		this.canvas = this.canvas_ref.nativeElement;
		this.canvas.width = this.size[0];
		this.canvas.height = this.size[1];
		this.context = this.canvas.getContext("2d");
		this.resizedFrame = this.applyResizingBehavior(this.makeRect(0, 0, this.canvas.width, this.canvas.height), {x: 0, y: 0, h: this.canvas.height, w: this.canvas.width});

		this.initializeCanvas();
		this.draw(this.shots);
	}

	/**
	 * @returns none
	 */
	public draw(shots: any[]): void {
		this.Progress(true);
		try {
			const w = this.resizedFrame.w;
			const h = this.resizedFrame.h;

			this.context.save();

			this.context.beginPath();
			this.context.rect(0, 100, w, 1);
			this.context.fillStyle = "rgb(128, 128, 128)";
			this.context.fill();

			const scale = 4;
			const text_offset_x = 10;
			const text_offset_y = -20;
			this.oval((w / 2) - (150 * scale), h - (150 * scale), (150 * scale) * 2, (150 * scale) * 2);
			this.context.strokeStyle = this.stroke_option.color;
			this.context.lineWidth = this.stroke_option.width;
			this.context.stroke();

			this.text("300", 10 + text_offset_x, h - (150 * scale) + text_offset_y, this.text_option);

			this.oval((w / 2) - (125 * scale), h - (125 * scale), (125 * scale) * 2, (125 * scale) * 2);
			this.context.strokeStyle = this.stroke_option.color;
			this.context.lineWidth = this.stroke_option.width;
			this.context.stroke();

			this.text("250", 10 + text_offset_x, h - (125 * scale) + text_offset_y, this.text_option);

			this.oval((w / 2) - (100 * scale), h - (100 * scale), (100 * scale) * 2, (100 * scale) * 2);
			this.context.strokeStyle = this.stroke_option.color;
			this.context.lineWidth = this.stroke_option.width;
			this.context.stroke();

			this.text("200", 10 + text_offset_x, h - (100 * scale) + text_offset_y, this.text_option);

			this.oval((w / 2) - (75 * scale), h - (75 * scale), (75 * scale) * 2, (75 * scale) * 2);
			this.context.strokeStyle = this.stroke_option.color;
			this.context.lineWidth = this.stroke_option.width;
			this.context.stroke();

			this.text("150", 10 + text_offset_x, h - (75 * scale) + text_offset_y, this.text_option);

			this.oval((w / 2) - (50 * scale), h - (50 * scale), (50 * scale) * 2, (50 * scale) * 2);
			this.context.strokeStyle = this.stroke_option.color;
			this.context.lineWidth = this.stroke_option.width;
			this.context.stroke();

			this.text("100", 10 + text_offset_x, h - (50 * scale) + text_offset_y, this.text_option);

			this.oval((w / 2) - (25 * scale), h - (25 * scale), (25 * scale) * 2, (25 * scale) * 2);
			this.context.strokeStyle = this.stroke_option.color;
			this.context.lineWidth = this.stroke_option.width;
			this.context.stroke();

			this.text("50", 10 + text_offset_x, h - (25 * scale) + text_offset_y, this.text_option);

			this.oval((w / 2) - (scale), h - (scale), (scale) * 2, (scale) * 2);
			this.context.strokeStyle = this.stroke_option.color;
			this.context.lineWidth = this.stroke_option.width;
			this.context.stroke();

			let total_name: string = "";
			let carry_name: string = "";
			let head_speed_name: string = "";
			let speed_name: string = "";
			let meet_name: string = "";
			let v_angle_name: string = "";
			let h_angle_name: string = "";

			let index: number = 0;

			if (shots) {
				shots.forEach((shot) => {
					if (shot.prizm) {
						const prizm = shot.prizm;
						const datalist = prizm.DataList;

						// Total
						const total = datalist[0];
						total_name = total.Name;
						const total_value = total.Value;

						// キャリー
						const carry = datalist[2];
						carry_name = carry.Name;
						const carry_value = carry.Value;

						// ヘッドスピード
						const head_speed = datalist[4];
						head_speed_name = head_speed.Name;
						const head_speed_value = head_speed.Value;

						// ボール初速
						const speed = datalist[5];
						speed_name = speed.Name;
						const speed_value = speed.Value;

						// ミート
						const meet = datalist[6];
						meet_name = meet.Name;
						const meet_value = meet.Value;

						// 打ち出し角 上下
						const v_angle = datalist[7];
						v_angle_name = ""; // v_angle.Name;
						const v_angle_value = v_angle.Value;

						// 打ち出し角 左右
						const h_angle = datalist[8];
						h_angle_name = ""; // h_angle.Name;
						const h_angle_value = h_angle.Value;

						const option = {
							line_color: this.color(index),
							point_color: "rgba(180, 180, 180, 0.8)",
							font: "bold 12px HelveticaNeue, \"Helvetica Neue\", Helvetica, Arial, sans-serif"
						};

						// const text_option = {
						// 	line_color: "rgba(100, 100, 100, 0.4)",
						// 	point_color: "rgba(180, 180, 180, 0.8)",
						// 	font: "bold 12px HelveticaNeue, \"Helvetica Neue\", Helvetica, Arial, sans-serif"
						// };

						// const meet_option = {
						// 	line_color: "rgba(100, 180, 180, 0.4)",
						// 	point_color: "rgba(180, 180, 180, 0.8)",
						// 	font: "bold 12px HelveticaNeue, \"Helvetica Neue\", Helvetica, Arial, sans-serif"
						// };

						// Total, carry
						this.lineTo(w / 2, h, h_angle_value + 90, 0, total_value * (scale / 2), option, (context) => {
						});

						// speed
						this.lineTo(this.size[0], 100, v_angle_value, 0, 200, option, (context) => {
						});

						// Total, carry
						this.pointTo(this.size[0], 100, 0, carry_value, total_value * (scale / 2), option, (context) => {
						});

						index++;
					} else {
						// Todo: error code messege
					}
				});
			} else {
				// Todo: error code messege
			}

			this.context.fillStyle = "rgb(0, 0, 0)";
			this.context.font = "13px HelveticaNeue, \"Helvetica Neue\", Helvetica, Arial, sans-serif";
			this.context.textAlign = "center";
			const textTotalHeight = 13 * 1.3;

			const v_textRect = this.makeRect(50, 0, 200, 21);
			this.context.fillText(v_angle_name, v_textRect.x, v_textRect.y + 12 + v_textRect.h / 2 - textTotalHeight / 2);

			const h_textRect = this.makeRect(50, 110, 200, 21);
			this.context.fillText(h_angle_name, h_textRect.x, h_textRect.y + 12 + h_textRect.h / 2 - textTotalHeight / 2);

			this.context.restore();
		} finally {
			this.Progress(false);
		}
	}

	/**
	 * @returns rect
	 */
	public applyResizingBehavior(rect: IRect, targetRect: IRect): IRect {
		if (targetRect === undefined || this.equalRects(rect, targetRect) || this.equalRects(targetRect, this.makeRect(0, 0, 0, 0))) {
			return rect;
		}

		const scales: ISize = this.makeSize(0, 0);
		scales.w = Math.abs(targetRect.w / rect.w);
		scales.h = Math.abs(targetRect.h / rect.h);

		scales.w = Math.min(scales.w, scales.h);
		scales.h = scales.w;

		const result: IRect = this.makeRect(Math.min(rect.x, rect.x + rect.w), Math.min(rect.y, rect.y + rect.h), Math.abs(rect.w), Math.abs(rect.h));
		result.w *= scales.w;
		result.h *= scales.h;
		result.x = targetRect.x + (targetRect.w - result.w) / 2;
		result.y = targetRect.y + (targetRect.h - result.h) / 2;
		return result;
	}

	/**
	 * @returns none
	 */
	public Progress(progress: boolean): void {
		this.progrssChange.emit(progress);
	}

}
